var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTikTok({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M10.37,1.56c.23,1.72,1.6,3.07,3.35,3.17v2.04c-.98.03-1.98-.23-2.76-.83-.1-.08-.2-.19-.29-.26-.03-.02-.03-.05-.08-.04v4.77c-.04,1.13-.49,2.14-1.23,2.86,0,0-.98.96-2.31,1.13-.3.04-.59.04-.59.04-.26,0-.52-.03-.64-.04,0,0,0,0,0,0-2.51-.38-4.11-2.89-3.37-5.33.58-1.9,2.57-3.15,4.54-2.85v2.22c-1.02-.12-2.12.3-2.36,1.38-.61,2.7,3.42,3.36,3.67.65V1.56s2.06,0,2.06,0Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTikTok);
export default __webpack_public_path__ + "static/media/TikTok.1535d6c019dc70ddb7ecfab980635080.svg";
export { ForwardRef as ReactComponent };